import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../shared/constants';
import { ResetPassword } from '../shared/models/resetpassword.model';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { NotificationService } from '../shared/services/notifications.service';
import { PasswordConfirmationValidatorService } from '../shared/services/passwordValidator.service';
import forge from 'node-forge';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
,  standalone: false
})
export class ResetPasswordComponent implements OnInit {
  public resetPasswordForm: FormGroup;
  public showSuccess: boolean;
  public showError: boolean;
  public errorMessage: string;
  constant: Constants = new Constants();
  private _token: string;
  private _email: string;
  resetHeading: string = "Reset Password";

  constructor(private _authService: BaseHttpService, private _passConfValidator: PasswordConfirmationValidatorService, 
    private _route: ActivatedRoute,private notificationService: NotificationService,private spinnerService: NgxSpinnerService,
    private router: Router) { }

  ngOnInit(): void {
   
    this.resetPasswordForm = new FormGroup({
      password: new FormControl('', [Validators.required]),
      confirm: new FormControl('')
    });
    this.resetPasswordForm.get('confirm').setValidators([Validators.required,
      this._passConfValidator.validateConfirmPassword(this.resetPasswordForm.get('password'))]);
    
      this._token = this._route.snapshot.queryParams['token'];
      this._email = this._route.snapshot.queryParams['email'];
  }

  public validateControl = (controlName: string) => {
    return this.resetPasswordForm.controls[controlName].invalid && this.resetPasswordForm.controls[controlName].touched
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.resetPasswordForm.controls[controlName].hasError(errorName)
  }

  public resetPassword = (resetPasswordFormValue) => {
    this.spinnerService.show();
    this.showError = this.showSuccess = false;
    if (!resetPasswordFormValue.password.match(this.constant.pwdRegex)) {
      this.notificationService.showError("Password should be at least 8 characters long and should contain one number,one character and one special character($,@,!,%,*,#,?,&)", "Error");
      this.spinnerService.hide();
      return 
    }
    if(resetPasswordFormValue.password != resetPasswordFormValue.confirmpassword){
      this.notificationService.showError("Passwords must match","Error");
      this.spinnerService.hide();
      return
    }
    let rsa = forge.pki.publicKeyFromPem(this.constant.publicKey);
    // let passwordEncrypt = window.btoa(rsa.encrypt(resetPasswordFormValue.password));
    // let confirmPasswordEncrypt = window.btoa(rsa.encrypt(resetPasswordFormValue.confirmpassword));
    let passwordEncrypt = window.btoa(
      rsa.encrypt(resetPasswordFormValue.password, 'RSA-OAEP', {
        md: forge.md.sha1.create()
      }))
    let confirmPasswordEncrypt = window.btoa(
      rsa.encrypt(resetPasswordFormValue.confirmpassword, 'RSA-OAEP', {
        md: forge.md.sha1.create()
      }))
    // const resetPass = { ... resetPasswordFormValue };
    let emailEncrypt = window.btoa(
      rsa.encrypt(this._email, 'RSA-OAEP', {
        md: forge.md.sha1.create()
      }))
    // let emailEncrypt =window.btoa(rsa.encrypt(this._email));

    const resetPassDto: ResetPassword = {
      password: passwordEncrypt,
      confirmPassword: confirmPasswordEncrypt,
      token: this._token,
      email: emailEncrypt
    }

    this._authService.post(this.constant.resetPassword, resetPassDto)
    .subscribe(_ => {
      this.showSuccess = true;
      this.notificationService.showSuccess("Password reset successful.","Success");
      this.spinnerService.hide();
      this.router.navigate(['/', 'login']);
    },
    error => {
      this.showError = true;
      this.errorMessage = error.error.errors.join(",");
      this.spinnerService.hide();
    })
  }

  Navigate() {
    this.router.navigate(['/', 'login']);

  }
}



